import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // Ignore Metamask and other extension errors
    if (
      error?.message?.includes('MetaMask') ||
      error?.message?.includes('ethereum') ||
      error?.message?.includes('web3') ||
      error?.stack?.includes('chrome-extension')
    ) {
      console.warn('Ignored extension error:', error);
      this.setState({ hasError: false });
      return;
    }
    
    console.error('Error caught by boundary:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen flex items-center justify-center bg-slate-50">
          <div className="text-center p-8">
            <h1 className="text-2xl font-bold text-slate-900 mb-4">Algo salió mal</h1>
            <p className="text-slate-600 mb-4">Por favor, recarga la página</p>
            <button
              onClick={() => window.location.reload()}
              className="px-4 py-2 bg-primary text-white rounded-lg hover:bg-primary/90"
            >
              Recargar
            </button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
